import React from "react";
import Today from "../components/Today";

const TodayPage = () => {
  return (
    <>
      <Today />
    </>
  );
};

export default TodayPage;
